
/* eslint-disable vue/no-reserved-component-names,vue/multi-word-component-names */
import VueTypes from 'vue-types'
import { Content } from './dropdown-style'
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Dropdown',
  components: {
    Content
  },
  props: {
    placement: VueTypes.string.def('bottomRight'),
    title: VueTypes.string,
    action: VueTypes.array.def(['hover']),
    class: VueTypes.string.def('strikingDash-dropdown')
  },
  data () {
    return {
      className: this.class
    }
  }
})
